import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarLoader from "../../../common-components/CalendarLoader";
import {
  getBackgroundColor,
  getBadgeColor,
} from "../../trainer-member-map/tmeMocksData";
import { ReloadIcon } from "../../../../images/icons/icons";

const TMECheckinBreakdown = ({ callFunction }) => {
  const {
    tmeCheckinBreakdown,
    tmeCheckinBreakdownError,
    tmeCheckinBreakdownLoading,
  } = useSelector((state) => state.prospects);

  const [breakdownData, setBreakdownData] = useState(null);

  useEffect(() => {
    if (
      !tmeCheckinBreakdownLoading &&
      !tmeCheckinBreakdownError &&
      tmeCheckinBreakdown?.status &&
      tmeCheckinBreakdown?.breakdown
    ) {
      setBreakdownData(tmeCheckinBreakdown.breakdown);
    } else {
      setBreakdownData(null);
    }
  }, [
    tmeCheckinBreakdownLoading,
    tmeCheckinBreakdownError,
    tmeCheckinBreakdown,
  ]);

  return (
    <div className="tme-analysis-logs-container mt30">
      <h3 className="tm-tb-header-title">
        Check-in Breakdown
        <button
          className="page-heading-reload-btn"
          onClick={callFunction}
          title="Reload"
          type="button"
        >
          <ReloadIcon />
        </button>
      </h3>

      {breakdownData && (
        <div className="tme-analysis-breakdown-grid mt15">
          {tmeCheckinBreakdownLoading ? (
            <CalendarLoader daysCount={4} shiftsPerDay={1} />
          ) : (
            Object.entries(breakdownData)?.map(([key, data]) => {
              return (
                <div
                  key={key}
                  className="tme-analysis-breakdown-card"
                  style={{ backgroundColor: getBackgroundColor(key) }}
                >
                  <div className="tme-analysis-breakdown-header">
                    <h4 className="tme-analysis-breakdown-card-title">
                      {data?.label || key}
                    </h4>
                    <span
                      className="tme-analysis-breakdown-badge"
                      style={{
                        backgroundColor: getBadgeColor(key),
                        color: "#ffffff",
                      }}
                    >
                      {data?.count} {data?.count === 1 ? "day" : "days"}
                    </span>
                  </div>
                  <p className="tme-analysis-breakdown-description">
                    {data?.description || ""}
                  </p>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default TMECheckinBreakdown;
